<div *ngIf="showTitle" class="h1 text-primary text-center fw-bold">
  Parent/Guardian Information
</div>

<form class="mt-4" [formGroup]="signUpForm" (ngSubmit)="signUp()">
  <div class="mb-3">
    <input id="emailAddress" type="email" class="form-control" formControlName="emailAddress"
           placeholder="Email Address" (blur)="checkUserExists()">
    <ua-display-validation-errors name='Email address' [control]="signUpForm.controls.emailAddress" [force]="formDirty">
    </ua-display-validation-errors>
  </div>

  <div class="row mb-3 g-2">
    <div class="col">
      <input id="firstName" type="text" class="form-control" formControlName="firstName"
             placeholder="First Name">
      <ua-display-validation-errors name='First name' [control]="signUpForm.controls.firstName"
                                    [force]="formDirty">
      </ua-display-validation-errors>
    </div>
    <div class="col">
      <input id="lastName" type="text" class="form-control" formControlName="lastName"
             placeholder="Last Name">
      <ua-display-validation-errors name='Last name' [control]="signUpForm.controls.lastName"
                                    [force]="formDirty">
      </ua-display-validation-errors>
    </div>
  </div>

  <div class="mb-3">
    <input id="phoneNumber" type="tel" class="form-control" formControlName="phoneNumber"
           placeholder="Phone Number">
    <ua-display-validation-errors name='Phone number' [control]="signUpForm.controls.phoneNumber"
                                  [force]="formDirty">
    </ua-display-validation-errors>
  </div>

  <div class="mb-3 form-check">
    <input class="form-check-input" id="guest" type="checkbox" checked (click)="togglePassword()"/>
    <label class="form-check-label" for="guest">Continue as Guest</label>
  </div>
  <div class="mb-3" *ngIf="showPasswordFields">
    <p>We will create an account for you where you can manage your party. Please create a password.</p>
    <div class="row g-2">
      <div class="col">
        <input id="password" type="password" class="form-control" formControlName="password"
               placeholder="Password">
      </div>
      <div class="col">
        <input id="confirmPassword" type="password" class="form-control" formControlName="confirmPassword"
               placeholder="Confirm Password">
      </div>
    </div>
    <div>
      <ua-display-validation-errors name='Password' [control]="signUpForm.controls.password"
                                    [force]="formDirty">
      </ua-display-validation-errors>
    </div>
    <div>
      <ua-display-validation-errors name='Confirmation' [control]="signUpForm.controls.confirmPassword"
                                    [force]="formDirty">
      </ua-display-validation-errors>
    </div>
    <div>
      <ua-display-validation-errors name='Passwords' [control]="signUpForm"
                                    [force]="formDirty">
      </ua-display-validation-errors>
    </div>
  </div>

  <div class="mb-4">
    <button type="submit" class="btn btn-lg btn-primary w-100">Next</button>
  </div>

  <div class="mb-5 text-center">
    <button type="button" class="btn btn-lg btn-outline-primary w-100" (click)="goBack()">Go Back</button>
  </div>
</form>
